module.exports = __webpack_public_path__ + "static/get_started-7e439c5be9d4d494aba1c8a5d620e681.png";